<template>
  <b-modal id="login-modal" lazy centered cancel-disabled ok-disabled size="lg" @hidden="hideModal" hide-footer>
    <div :class="isRTL ? 'rtl' : ''">
      <div v-if="showLogin">
        <div class="alert mx-4">
          <p class="mb-0">{{ $t('welcome') }}</p>
          <p>{{ $t('subtitle') }}</p>
        </div>
        <div class="row mx-4">
          <login v-if="!isLoggedIn && !isUserVerified" :countries="countries" :userCountry="userCountry" class="col-12 col-md border-right border-gray" />
          <register v-if="!isLoggedIn && !isUserVerified" :countries="countries" :userCountry="userCountry" class="col-12 col-md" />
          <VerifyOtp v-if="isLoggedIn && !isUserVerified" class="col-12" />
        </div>
      </div>
      <div v-else>
        <div class="alert mx-4">{{ $t('confirmation', { email: $store.getters['auth/user'].email }) }}</div>
      </div>
      <div slot="modal-footer" class="w-100"></div>
    </div>
  </b-modal>
</template>
<script>
import RegisterComponent from './Register.vue';
import LoginComponent from './Login.vue';
import VerifyOtp from './VerifyOtp.vue';
import { mapGetters } from 'vuex';

export default {
  data: function () {
    return {
      showLogin: true,
      countries: null,
      userCountry: null,
    };
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'auth',
  },
  mounted() {
    this.loadCountries();
  },
  computed: {
    modal: function () {
      return this.$store.state.auth.modal;
    },
    ...mapGetters({
      isUserVerified: 'auth/isUserVerified',
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },
  watch: {
    modal: function (value) {
      if (value == true) {
        this.$root.$emit('bv::show::modal', 'login-modal');
      } else {
        this.$root.$emit('bv::hide::modal', 'login-modal');
      }
    },
  },
  components: {
    Login: LoginComponent,
    Register: RegisterComponent,
    VerifyOtp,
  },
  methods: {
    hideModal: function () {
      this.$store.dispatch('auth/hideModal');
    },
    loadCountries: async function () {
      this.$http.get('/api/countries').then(resp => {
        this.countries = resp.data;

        this.$set(this, 'userCountry', this.countries[0]);
        this.loadUserCountry();
      });
    },
    loadUserCountry: async function () {
      let country = localStorage.getItem('user_country');
      if (!country) return;
      this.$set(
        this,
        'userCountry',
        this.countries.find(c => c.iso === country)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.alert {
  background: $dark-blue;
  color: $white;
}
</style>
